import React, { Fragment, useRef } from "react"
import PropTypes from "prop-types"
import {
  useTable,
  useGlobalFilter,
  useAsyncDebounce,
  useExpanded,
  usePagination,
} from "react-table"
import { Table, Row, Col, Button, FormGroup, Input } from "reactstrap"
import { DefaultColumnFilter } from "components/Common/filters"
import { useEffect } from "react"
import { useState } from "react"
import JobListGlobalFilter from "components/Common/GlobalSearchFilter"
import Flatpickr from "react-flatpickr";
import { HandWorkCostingStatus } from "_mock/Static_data"

// Define a default UI for filtering
function GlobalFilter({
  setGlobalFilter,
  isJobListGlobalFilter,
  filterData,
  value,
  setValue,
}) {
  const onChange = useAsyncDebounce(value => {
    setGlobalFilter(value || undefined)
    filterData(value)
  }, 200)

  return (
    <React.Fragment>
      <Col md={12}>
        <div className="search-box w-full d-inline-block">
          <div className="position-relative">
            <label htmlFor="search-bar-0" className="search-label">
              <span id="search-bar-0-label" className="sr-only">
                Search this table
              </span>
              <input
                onChange={e => {
                  setValue(e.target.value)
                  onChange(e.target.value)
                }}
                id="search-bar-0"
                type="text"
                className="form-control"
                placeholder={"Search…"}
                value={value || ""}
              />
            </label>
            <i className="bx bx-search-alt search-icon"></i>
          </div>
        </div>
      </Col>
      {isJobListGlobalFilter && <JobListGlobalFilter />}
    </React.Fragment>
  )
}

const EmployeeSalaryTable = ({
  columns,
  data,
  className,
  pagePerSize,
  isLoading,
  userFilter, setUserFilter,
  users,
  writeDataToExcel,
  setMonth,
  totalCash, totalKiara, totalPVTLTD
}) => {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    gotoPage,
    setPageSize,
    state: { pageSize },
  } = useTable(
    {
      columns,
      data,
      defaultColumn: { Filter: DefaultColumnFilter },
      initialState: {
        pageSize: 20000,
        sortBy: [
          {
            desc: true,
          },
        ],
      },
    },
    useGlobalFilter,
    useExpanded,
    usePagination
  )
  const handlesort = column => { }
  const [pageIndex, setpageIndex] = useState(1)
  const [prevValue, setPrevValue] = useState();


  const generateSortingIndicator = column => {
    return column.isSorted ? (column.isSortedDesc ? "🔽" : "🔼") : ""
  }

  const onChangeInSelect = event => {
    setPageSize(Number(event.target.value))
  }

  const onChangeInInput = event => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0
    gotoPage(page)
  }

  const [isMobile, setisMobile] = useState(window.innerWidth < 924)
  const [value, setValue] = React.useState()
  const [isIpad, setIsIpad] = useState(window.innerWidth < 924)
  const [TaskTitleTypes, setTaskTitleTypes] = useState(
    (JSON.parse(localStorage?.getItem("authUser")).TaskTitleTypes)
  )


  useEffect(() => {
    pagePerSize(pageSize, pageIndex, value)
    setPrevValue(value);
  }, [pageSize, value, pageIndex])

  useEffect(() => {
    if (value !== prevValue) {
      setpageIndex(1);
    }
  }, [value]);

  useEffect(() => {
    setpageIndex(1);
  }, [pageSize]);

  const margin = {
    marginTop: isMobile ? "" : "",
  }

  return (
    <Fragment>
      <Row className="">
        <Col md={8} style={{ marginTop: "10px" }}>
          <Row>
            {(JSON.parse(localStorage.getItem("authUser")).RoleName == "Admin" || JSON.parse(localStorage.getItem("authUser")).RoleName == "Master") &&
              <>
                <Col md="3" className="table-header" style={{ marginBottom: isIpad ? "10px" : '' }} >
                  <Input
                    type="select"
                    id="validationCustom01"
                    className="form-control"
                    name="taskType"
                    onChange={e => {
                      setUserFilter(e.target.value)
                    }}
                    value={userFilter}
                  >
                    <option value={0}>Select User</option>
                    {users.map((item, index) => {
                      return (
                        <option key={index} value={item.Key}>
                          {item.Value}
                        </option>
                      )
                    })}
                  </Input>
                </Col>
              </>
            }

            <Col md={4} className="" style={{ marginBottom: isMobile ? "10px" : '' }}>
              <Input
                type="month"
                dateFormat="M/YYYY"
                className="form-control"
                defaultValue={new Date().toISOString().slice(0, 7)}
                onChange={e => setMonth(e.target.value)}
              />
            </Col>
          </Row>
        </Col>
        <Col md={3} className="text-end" style={{ fontWeight: "500", fontSize: "15px" }}>
          <div>Total Cash: <span style={{ color: "blue" }}> <i className="mdi mdi-currency-inr p-0"></i>{new Intl.NumberFormat('en-IN', {
            currency: 'INR',
            minimumFractionDigits: 2,
          }).format(Math.round(totalCash || 0))} </span> </div>
          <div>Total Kiara: <span style={{ color: "blue" }}>

            <i className="mdi mdi-currency-inr p-0"></i>{new Intl.NumberFormat('en-IN', {
              currency: 'INR',
              minimumFractionDigits: 2,
            }).format(Math.round(totalKiara || 0))}
          </span></div>
          <div>Total PVT. LTD.: <span style={{ color: "blue" }}>
            <i className="mdi mdi-currency-inr p-0"></i>{new Intl.NumberFormat('en-IN', {
              currency: 'INR',
              minimumFractionDigits: 2,
            }).format(Math.round(totalPVTLTD || 0))}
          </span></div>
        </Col>
        <Col md={1}>
          <Row>
            <div style={{ display: "flex", gap: "10px", justifyContent: "end", marginTop: isIpad ? "3px" : "10px" }} className="mb-2">
              <div style={margin}>
                {data.length > 0 ? (<button
                  type="button"
                  className="btn btn-excel  btn-label"
                  onClick={writeDataToExcel}>
                  Excel
                  <i className="far fa-file-excel label-icon"></i>
                </button>
                )
                  :
                  (
                    <button
                      type="button"
                      className="btn  btn-excel  btn-label"
                      style={{ cursor: "not-allowed" }}>
                      Excel <i className="far fa-file-excel label-icon"></i>
                    </button>
                  )}
              </div>
              {/* {((TaskTitleTypes == null)) && (

                <div className="d-flex" style={{ justifyContent: isIpad ? "end" : "end", gap: "15px", marginLeft: isIpad ? "6px" : "0px" }}>
                  <div className="text-sm-end">
                    <Button
                      type="button"
                      color="primary"
                      className="btn  mb-2 "
                      onClick={handleCreateUpdateEmployeeSalary}
                    >
                      <i className="mdi mdi-plus-circle-outline me-1" />
                      Create
                    </Button>
                  </div>
                </div>
              )} */}
            </div>
          </Row>
        </Col>
      </Row>

      <div className="table-responsive react-table table-scroll-container">
        <Table bordered  {...getTableProps()} className={className}>
          <thead className="table-light table-nowrap table-sticky-header">
            {headerGroups.map(headerGroup => (
              <tr key={headerGroup.id} {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map(column => (
                  <th
                    key={column.id}
                    onClick={() => {
                      handlesort(column)
                    }}
                    className={` ${((TaskTitleTypes != null && column.Header == 'Action') ? 'column-display' : "")} `}
                    {...column.getHeaderProps({
                      style: {
                        minWidth: column.minWidth,
                        maxWidth: column.maxWidth,
                        width: column.width,
                        fontSize: column.Header == "Name" ? "15px" : ""
                      },
                    })}
                  >
                    <div className={`mb-0`}>
                      {column.render("Header")}
                      {generateSortingIndicator(column)}
                    </div>
                  </th>
                ))}
              </tr>
            ))}
          </thead>

          {page.length ? (
            <tbody {...getTableBodyProps()}>
              {page.map(row => {
                prepareRow(row)
                return (
                  <Fragment key={row.getRowProps().key}>
                    <tr>
                      {row.cells.map(cell => {
                        const { Status } = cell.row.original;
                        return (
                          <td
                            key={cell.id}
                            className={` text-nowrap ${((TaskTitleTypes != null && cell.column.Header == 'Action') ? 'column-display' : "")}`}
                            {...cell.getCellProps({
                              style: {
                                minWidth: cell.minWidth,
                                maxWidth: cell.maxWidth,
                                width: cell.width,
                                backgroundColor: cell.column.Header == "Total Salary" ? "#d7edd5" : cell.column.Header == "Salary" ? "#d7edd5" : "",
                                fontWeight: "600",
                                fontSize: cell.column.Header == "Name" ? "15px" : ""
                              },
                            })}
                          >
                            {cell.render("Cell")}
                          </td>
                        )
                      })}
                    </tr>
                  </Fragment>
                )
              })}
            </tbody>
          ) : (
            <tbody
              style={{
                textAlign: "center",
                justifyContent: "center",
                alignItems: "center",
                height: "40px",
              }}
            >
              <tr>
                <td colSpan={headerGroups[0].headers.length}>
                  {isLoading ? "Loading..." : "No Record Found"}
                </td>
              </tr>
            </tbody>
          )}
        </Table>
      </div>
    </Fragment >
  )
}

EmployeeSalaryTable.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
}

export default EmployeeSalaryTable
